import { render, staticRenderFns } from "./_partnerList.vue?vue&type=template&id=6d27142e&scoped=true&lang=pug&"
import script from "./_partnerList.vue?vue&type=script&lang=js&"
export * from "./_partnerList.vue?vue&type=script&lang=js&"
import style0 from "./_partnerList.vue?vue&type=style&index=0&id=6d27142e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d27142e",
  null
  
)

export default component.exports